// extracted by mini-css-extract-plugin
export default {"wrapper":"Error404_wrapper__Xpz37","errorImg":"Error404_errorImg__RKBJw","errorText":"Error404_errorText__rHLO5","button":"Error404_button__jGkZJ"};